var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefrells(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.776367,
    y: 0.590088,
    width: 76,
    height: 76,
    rx: 25,
    fill: "#FFEDD4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6051 40.9167H45.1051M33.6051 48.5833H39.3551M24.0217 23.6667V54.3333C24.0217 55.35 24.4256 56.325 25.1445 57.0439C25.8634 57.7628 26.8384 58.1667 27.8551 58.1667H50.8551C51.8717 58.1667 52.8467 57.7628 53.5656 57.0439C54.2845 56.325 54.6884 55.35 54.6884 54.3333V31.9888C54.6883 31.4781 54.5862 30.9726 54.3881 30.502C54.1899 30.0313 53.8998 29.605 53.5346 29.248L45.0246 20.9258C44.3084 20.2256 43.3467 19.8335 42.3451 19.8333H27.8551C26.8384 19.8333 25.8634 20.2372 25.1445 20.9561C24.4256 21.675 24.0217 22.65 24.0217 23.6667Z",
    stroke: "#F54A00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1884 19.8333V27.5C43.1884 28.5167 43.5922 29.4917 44.3111 30.2106C45.03 30.9295 46.005 31.3333 47.0217 31.3333H54.6884",
    stroke: "#F54A00",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefrells);
export default __webpack_public_path__ + "static/media/Refrells.30bd471775445eae7011554139f390a4.svg";
export { ForwardRef as ReactComponent };